import React from 'react';
import history from './history';

const Link = function ({to, children, ...rest}) {

    const style = {
        display: 'inline-block',
        cursor: 'pointer'
    };

    return (
        <div style={style} onClick={() => {history.push(to)}} {...rest}>
            {children}
        </div>
    )
};

export default Link;


// WEBPACK FOOTER //
// ./src/components/global/Link.js